import Currency from "react-currency-formatter";
import React, { useState } from "react";
import infoIcon from "./assets/iconInfo.svg";
import moment from "moment";
import { AiOutlineEye, AiOutlineInfoCircle } from "react-icons/ai";
import { FiDownload, FiMail } from "react-icons/fi";
import { ImSpinner6 } from "react-icons/im";
import { toast } from "react-toastify";

import api from "services/api";

import theme from "styles/theme";
import {
  ActionSpinner,
  Bullet,
  BulletMobile,
  Container,
  ContainerItems,
  ContentActions,
  ContentDate,
  ContentItem,
  ItemContent,
  ItemTitle,
  Month,
  TooltipAiOutlineInfoCircle,
  Year,
} from "./styles";

interface IBoletoItem {
  open: () => void;
  installment: any;
  invoice: any;
}

const BoletoItem = ({
  open,
  installment,
  invoice,
}: IBoletoItem): JSX.Element => {
  const [status, setStatus] = useState("");

  const sendEmail = async (): Promise<void> => {
    setStatus("email");
    const accessToken = localStorage.getItem(
      "@UltragazEmpresarial:accessToken"
    );

    try {
      const headers = {
        access_token: accessToken,
      };

      const body = {
        deliveryMethod: "EMAIL",
      };
      await api.post(`industrial/bill/v1/bills/${invoice?.id}`, body, {
        headers,
      });
      toast.success(`Boleto enviado para o e-mail cadastrado`);
    } catch (err) {
      if (err.response) {
        const erro = err.response.data;
        if (erro) {
          const { message } = err.response.data;
          if (err.response.status !== 401) {
            toast.error(message);
          }
        } else if (err.response.status !== 401) {
          toast.error("Ocorreu um erro interno na aplicação");
        }
      } else {
        toast.error("Ocorreu um erro interno na aplicação");
      }
    }
    setStatus("");
  };

  const download = async (): Promise<void> => {
    setStatus("download");
    const accessToken = localStorage.getItem(
      "@UltragazEmpresarial:accessToken"
    );
    try {
      const headers = {
        access_token: accessToken,
      };
      const body = {
        deliveryMethod: "DOWNLOAD",
        isReduced: false,
      };
      const response = await api.post(
        `industrial/bill/v1/bills/${invoice.id}`,
        body,
        { headers, responseType: "blob" }
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      const referenceMonth = (installment.referenceMonth || "").split("/");
      link.setAttribute(
        "download",
        `Ultragaz_${moment(`${referenceMonth[1]}/01/${referenceMonth[0]}`)}_${
          invoice.id
        }.pdf`
      );
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    } catch (err) {
      if (err.response) {
        const erro = err.response.data;
        if (erro) {
          const { message } = err.response.data;
          if (err.response.status !== 401) {
            toast.error(message);
          }
        } else if (err.response.status !== 401) {
          toast.error("Ocorreu um erro interno na aplicação");
        }
      } else {
        toast.error("Ocorreu um erro interno na aplicação");
      }
    }
    setStatus("");
  };

  return (
    <Container>
      <ContentDate>
        <BulletMobile status={installment.status} />
        <Month>{moment(installment.dueDate).format("MMM")}</Month>
        <Year>{moment(installment.dueDate).format("YYYY")}</Year>
      </ContentDate>
      <ContainerItems>
        <ContentItem>
          <ItemTitle>Vencimento</ItemTitle>
          <ItemContent>
            {moment(installment.dueDate).format("DD/MM/YYYY")}
          </ItemContent>
        </ContentItem>
        <ContentItem>
          <ItemTitle>Valor</ItemTitle>
          <ItemContent>
            {installment.amountOriginal ? (
              <Currency
                quantity={installment.amountOriginal}
                currency="BRL"
                locale="pt"
              />
            ) : (
              `R$ ${invoice.totalAmount}`
            )}
          </ItemContent>
        </ContentItem>
        <ContentItem showMobile={false}>
          <ItemTitle>Situação</ItemTitle>
          <ItemContent>
            <Bullet status={installment.status} />
            {installment?.status?.replace("_", " ")}
            {installment?.status === "VENCIDO" && (
              <img src={infoIcon} alt="Atenção" />
            )}
          </ItemContent>
        </ContentItem>
        <ContentActions>
          <AiOutlineEye onClick={open} />
          {status === "email" ? (
            <ActionSpinner>
              <ImSpinner6 />
            </ActionSpinner>
          ) : (
            <FiMail onClick={sendEmail} />
          )}
          {status === "download" ? (
            <ActionSpinner>
              <ImSpinner6 />
            </ActionSpinner>
          ) : (
            <FiDownload onClick={download} />
          )}
          <AiOutlineInfoCircle
            data-tip="info-compensacao"
            data-for="info-compensacao"
          />
          <TooltipAiOutlineInfoCircle
            id="info-compensacao"
            place="left"
            type="dark"
            effect="solid"
            offset={{
              left: 10,
              right: 10,
              top: 10,
              bottom: 10,
            }}
            arrowColor={theme.colors.blueClean}
            backgroundColor={theme.colors.blueClean}
            textColor={theme.colors.blue}
          >
            <span>Tempo de compensação do boleto</span>
            <p>
              A Ultragaz recebe a confirmação de pagamento, em média, 3 dias
              úteis após o pagamento. Após este prazo o status de seu boleto
              será atualizado em nossos canais.
            </p>
          </TooltipAiOutlineInfoCircle>
        </ContentActions>
      </ContainerItems>
    </Container>
  );
};

export default BoletoItem;
